module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-Bold.22037adb.woff";